import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/Home/Home";
// Import the new page components
import About from "./components/About/About";
import Navbar from './components/Home/Components/Navbar/Navbar'
import Header from './components/Home/Components/Header/Header'
import Footer from './components/Home/Components/Footer/Footer'
import News from "./components/News/News";
import ContactUs from "./components/ContactUs/ContactUs";
import Careers from "./components/Careers/Careers";
import Security from "./components/SecurityPage/SecurityPage";
import Pricing from "./components/Pricing/Pricing";
import Customers from "./components/Customers/Customers";


function App() {
  return (
    <Router>
      {/* <Navbar/> */}
      <Header />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/security" element={<Security />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/customers" element={<Customers />} />
        </Routes>
      </div>
      <Footer/>
    </Router>
  );
}

export default App;
